import moment from 'moment';

export const convertToISODateString = (
  value: moment.Moment | null | undefined
): string => {
  if (!value) {
    return '';
  }
  return value.isValid() ? value.format('YYYY-MM-DD') : 'invalid-date';
};

export type DateWithValidity = {
  date: moment.Moment | null;
  isValid: boolean;
};

export type EDateSharedType = {
  lang?: string;
  name?: string;
  disabled?: boolean;
  /** Date value in ISO format (YYYY-MM-DD) */
  value?: string;
  /** Use this prop to pass a date directly instead of converting it to a string first. */
  dateValue?: moment.Moment | null;
  /** Maximum date in ISO format (YYYY-MM-DD) */
  maxDate?: string;
  /** Minimum date in ISO format (YYYY-MM-DD) */
  minDate?: string;
  /** Gets a fake on change event to be compatible with normal input elements */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * Can be used to get a date and a validity flag from the component.
   * Use `onChange` if you rather want the date as a string with no information
   * whether it's considered valid or not.
   */
  onDateChanged?: (date: DateWithValidity) => void;
};
